import { gql } from '@apollo/client';

import {
  UNFAVORITE_ADDRESS_OPERATION,
  CREATE_ADDRESS_OPERATION,
} from 'utils/constants';

export const UNFAVORITE_ADDRESS = gql`
  mutation ${UNFAVORITE_ADDRESS_OPERATION}($addressId: [ID!]!) {
    deleteAddress(input: $addressId)
  }
`;

export const CREATE_ADDRESS = gql`
  mutation ${CREATE_ADDRESS_OPERATION}($input: [AddressRecordInput!]!) {
    createAddress(input: $input) {
      addressId
    }
  }
`;
